export default __webpack_public_path__ + "static/cca-lockup-99571809551370e6db4ddde52941c853.png";